import React, {Component, Fragment} from 'react';
import {observer, inject} from 'mobx-react';
import {Link} from 'react-router-dom';
import intl from 'react-intl-universal';
import queryString from "query-string";

import EmptyResponseMessage from '../EmptyResponseMessage';
import ZoomControl from "../ZoomControl";
import DrawerButton from "../DrawerButton";
import LayerToggle from "../LayerToggle";
import DrawerContainer from "../DrawerContainer";
import MapButtons from "../MapButtons";

import './BottomContainerDesktop.css';

@inject("appStore")
@observer
class BottomContainerDesktop extends Component {
    constructor(props) {
        super(props);
        this.hideFinishButton = !!queryString.parse(document.location.search).hideMapFinishBtn;

        this.state = {
            emptyResponse: !!(props.emptyResponseRoute && this.props.appStore.appConfig.map.bypassMode),
        };
    }

    componentDidUpdate() {
        if (this.props.emptyResponseRoute && this.props.appStore.appConfig.map.bypassMode && !this.state.emptyResponse) {
            this.setState({ emptyResponse: true });
        }
    }

    getComp = () => {
        if (this.props.appStore.hasDemographics()) {
            const mapContent = this.props.appStore.appConfig.content.map;

            return this.props.appStore.appConfig.map.bypassMode && this.props.appStore.elementStore.elements.length < 1 ? (
                <div
                    className={'finishedButton' + (this.props.appStore.drawer.open ? ' drawer-open ' : '')}
                    onClick={() => this.setState({ emptyResponse: true })}>
                        {mapContent['finish_button']}
                        <i className="fas fa-angle-right" aria-hidden="true"></i>
                    </div>
                ) : (
                    <Link className={'finishedButton' + (this.props.appStore.drawer.open ? ' drawer-open ' : '') + ((this.props.appStore.editMode || this.props.appStore.elementStore.elements.length < 1) ? ' editMode ' : '')}
                        to={`/survey`}>
                        {mapContent['finish_button']}
                        <i className="fas fa-angle-right" aria-hidden="true"></i>
                    </Link>
                );
        } else {
            return (<div
                className={'finishedButton' + (this.props.appStore.drawer.open ? ' drawer-open ' : '') + (this.props.appStore.editMode ? ' editMode ' : '')}
                onClick={() => this.props.appStore.submitData('', (responseVal) => {
                    if (responseVal) {
                        this.props.navigate('/end');

                    } else {
                        this.props.navigate('/error');
                    }
                })}>
                {'Submit'}
                <i className="fas fa-angle-right" aria-hidden="true"></i>
            </div>);
        }
    };

    render() {
        let questionTypes = Object.keys(this.props.appStore.appConfig.questions).filter((type) => this.props.appStore.appConfig.questions[type].length > 0);
        return (
            <div className="BottomContainerDesktop">
                {this.props.appStore.appConfig.map.bypassMode && <EmptyResponseMessage visible={this.state.emptyResponse} setVisible={visible => this.setState({ emptyResponse: visible })}/>}

                <div className="bottomContainer">
                    <div className="innerContainer">
                        <div className="flexContainer start mapControls">
                            {this.props.appStore.appConfig.map.zoomLocations &&
                            this.props.appStore.appConfig.map.zoomLocations.length > 0 &&
                            <MapButtons/>}

                            <ZoomControl/>

                            {!this.props.appStore.appConfig.map.nonSpatial && Object.keys(this.props.appStore.appConfig.map.baseLayers).length > 1 &&
                            <LayerToggle/>
                            }

                        </div>
                        <div className="drawerButtons flexContainer">
                            {questionTypes.map((type, index) =>
                                <DrawerButton key={type}
                                              questionType={type}>
                                    {type}
                                </DrawerButton>
                            )}
                        </div>
                        <div className="flexContainer end allDone">
                            {!this.hideFinishButton && this.getComp()}
                        </div>
                    </div>
                    {this.props.appStore.drawer.open && <DrawerContainer/>}
                </div>
            </div>
        );
    }
}

export default BottomContainerDesktop;



// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/BottomContainerDesktop/index.js